import React from 'react';

// Styles & Assets
import styles from './TableConstants.module.css';

// Interfaces
import { Column } from '../../../interfaces/Columns';
import { HasID } from '../../../interfaces/UtilInterfaces';

interface Props<T> {
    rows: T[]
    columns: Column<T>[]
    errorCells?: { [key: number]: number[] }
}

function TableConstants<T extends HasID>({ rows, columns, errorCells }: Props<T>) {    

    return (
        <table className={styles.table}>
            <thead className={styles.header}>
                <tr className={styles.headerRow}>
                    {columns.map(col =>
                        <th className={styles.cell} key={col.id}>{col.name()}</th>
                    )}
                </tr>
            </thead>
            <tbody className={styles.body}>
                {rows.map(row =>
                    <tr key={row.id}>
                        {columns.map(col =>
                            <td
                                key={col.id}
                                className={`${styles.rowCell} ${col.classBody ?? ''}`}
                                style={errorCells && row.id !== undefined && errorCells[row.id]?.includes(col.id) ?
                                    { backgroundColor: '#ff0000cc' } : {}
                                }
                            >
                                {col.element?.(row)}
                            </td>
                        )}
                    </tr>
                )}
            </tbody>
        </table >
    );
}

export default TableConstants;